
<div class="parent fx-row">
  <div class="left">
    <about-company></about-company>
  </div>
  <div class="right">
    <section>
      <form [formGroup]="forgetPassword" (ngSubmit)="onSubmit()">
        <mat-card>
          <h2>
            Forgot Password?
          </h2>
          <h5 class="mat-h5-paragraph">Enter your registered email id to receive a reset link</h5>
          <mat-card-content>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" hideRequiredMarker class="email-field">
              <mat-label>Enter Email Id</mat-label>
              <input class="forgetPassword-email-input" matInput formControlName="mail" autocomplete="off">
              <mat-icon matSuffix class="email-icon">mail_outline</mat-icon>
              @if (forgetPassword.get('mail').touched && forgetPassword.get('mail').hasError('required')) {
                <mat-error>Email Id is required</mat-error>
              }
              @if (forgetPassword.get('mail').touched && forgetPassword.get('mail').hasError('email')) {
                <mat-error>Enter valid email address</mat-error>
              }
            </mat-form-field>
          </mat-card-content>
          <mat-card-actions>
            <div class="button-flex-container">
              <a class="back-to-login" (click)="onCancel()">Back to Login</a>
              <button type="submit" class="material-cust-large-button" color="primary">SUBMIT</button>
            </div>
          </mat-card-actions>
        </mat-card>
      </form>
    </section>
  </div>
</div>
